/*=========================================================================================
  File Name: moduleTreatments.js
  Description: Treatment Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from "./moduleTreatmentsState.js"
import mutations from "./moduleTreatmentsMutations.js"
import actions from "./moduleTreatmentsActions.js"
import getters from "./moduleTreatmentsGetters.js"

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

